/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_New_Lot_Code_LabelInputs */

const vi_pkl_new_lot_code_label = /** @type {(inputs: Pkl_New_Lot_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã lô (auto-gen nếu trống)`)
};

/**

* @param {Pkl_New_Lot_Code_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_new_lot_code_label = /** @type {((inputs?: Pkl_New_Lot_Code_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_New_Lot_Code_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_new_lot_code_label(inputs)
});